/*** COUNTDOWN ***/

import { CLASSPREFIX } from "../config/constants"
import Time from "./Time";
export default class Countdown extends Time {
    totalTime: number; // Miliseconds
    usedTime: number = 0; // Miliseconds
    timeString: string;
    timeStringUsedTime: string;
    countdownOptions: any;
    startTime: number;
    endTime: number;
    counter: ReturnType<typeof setInterval>;
    targets: { [countdown: string]: HTMLElement; };

    // TOTALTIME ES RECIBIDO EN SEGUNDOS
    constructor(totalTime: number, countdownOptions?: any) {
        super()
        this.totalTime = this.secToMilisec(totalTime);
        this.countdownOptions = countdownOptions;
        this.init()
    }

    init() {
        this.startCounter()
    }

    // CREA LA BARRA DE PROGRESO
    createProgressBar(): HTMLProgressElement {
        let nwProgressBar: HTMLProgressElement = document.createElement('progress')
        nwProgressBar.classList.add(`${CLASSPREFIX}-trivia-countdown__progress`)
        nwProgressBar.setAttribute("max", "100")
        return nwProgressBar
    }

    // CREA EL CONTADOR
    createCounterSpan(): HTMLSpanElement {
        let nwCounterSpan: HTMLSpanElement = document.createElement('span')
        nwCounterSpan.classList.add(`${CLASSPREFIX}-trivia-countdown__text`)
        nwCounterSpan.innerHTML = '00:00'
        return nwCounterSpan
    }

    // CREA EL CONTENEDOR DEL PROGRESO
    createProgressContainer(): HTMLElement {
        this.targets = { counterSpan: this.createCounterSpan(), progressBar: this.createProgressBar() }
        let nwProgressContainer: HTMLElement = document.createElement('div')

        nwProgressContainer.classList.add(`${CLASSPREFIX}-trivia-countdown`)
        nwProgressContainer.insertAdjacentElement('beforeend', this.targets.counterSpan)
        nwProgressContainer.insertAdjacentElement('beforeend', this.targets.progressBar)

        return nwProgressContainer
    }

    // ACTUALIZA EL CONTADOR EN EL DOM
    updateCounter() {
        let { counterSpan, progressBar } = this.targets
        let percentage = this.calculatePercentage(this.endTime);

        counterSpan.innerHTML = this.timeString
        progressBar.setAttribute("value", `${percentage}`)
    }

    // INICIALIZA EL CONTADOR
    startCounter() {
        this.startTime = +new Date();
        this.counter = setInterval(() => {
            this.usedTime = Math.floor((+new Date() - this.startTime));
            this.endTime = this.totalTime - this.usedTime;
            this.timeString = this.calculateTime(this.endTime)
            this.timeStringUsedTime = this.calculateTime(this.usedTime)
            this.updateCounter()
            if (this.endTime <= 0) this.stopCounter(true)
        }, 30)
    }

    // DETIENE EL CONTADOR
    stopCounter(overTime?: boolean) {
        let { onOverTime, onEnded } = this.countdownOptions

        if (overTime) {
            onOverTime && onOverTime(this)
            this.endTime = 0
        }

        clearInterval(this.counter)
        onEnded && onEnded(this)
    }

    // CALCULA EL PORCENTAJE DE TIEMPO
    calculatePercentage(nwTime: number): number {
        return (nwTime * 100) / this.totalTime;
    }
}